import { isString } from 'lodash'

/**
 * YYYY-MM-DD
 */
export type DateOnlyString = string

/**
 * ISO DateTime
 */
export type DateTimeString = string

const DateOnlyPattern = /^\d{4}-\d{2}-\d{2}$/
const ISOPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/

export function isISODateString(value: any): value is DateOnlyString | DateTimeString {
  return isString(value) && (DateOnlyPattern.test(value) || ISOPattern.test(value))
}